<template>
    <div>
        <div class="card-body">
            <el-row :gutter="20">
                <el-col :span="10">
                    美术班活动
                </el-col>
                <el-col :span="11">
                    金额：1200
                </el-col>
                <el-col :span="3">
                    <el-button  @click="handleSettlement(1200,'美术班活动','C')">结算</el-button>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="10">
                    春秋班任意定金
                </el-col>
                <el-col :span="11">
                    金额：<el-input v-model="balance" style="width: 100px"></el-input>
                </el-col>
                <el-col :span="3">
                    <el-button  @click="handleSettlement(balance,'春秋班定金','B')">结算</el-button>
                </el-col>
            </el-row>
        </div>
        <el-dialog
                title="定金结算"
                :visible.sync="$parentInfo.earnest.settleDialogVisible"
                width="900px"
                height="700px"
                :before-close="handleClose"
                append-to-body>
            <Dialog_Settlement v-if="$parentInfo.earnest.settleDialogVisible"></Dialog_Settlement>
        </el-dialog>
    </div>
</template>

<script>
    import Dialog_Settlement from "./dialogs/Dialog_Settlement";
    export default {
        name: "Index",
        data() {
            return {
                balance:0
            };
        },
        components: {
            'Dialog_Settlement': Dialog_Settlement
        },
        computed: {

        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
        },
        methods: {
            handleSettlement(balance,remark,prefix){
                this.$parentInfo.earnest.dialog_settlement.sumPay=balance;
                this.$parentInfo.earnest.dialog_settlement.remark=remark;
                this.$parentInfo.earnest.dialog_settlement.prefix=prefix;
                this.$parentInfo.earnest.settleDialogVisible=true;
            },
            handleClose(done) {
                done();
            }
        }
    }
</script>

<style scoped>

</style>